import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { getTitleDecoration } from "utils/common";
import { applyPromotion } from "features/Promotion/promotionSlice";
import { SERVICE } from "constants/global";

const ModalSubmit = ({ check, openFn, closeFn, open = null }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const search = location.search;
  const p = new URLSearchParams(search).get("p");
  const q = new URLSearchParams(search).get("q");

  // redux store
  const { applySuccess, promotion, promotion_set, list, message } = useSelector(
    (state) => state.promotion
  );

  useEffect(() => {
    // check apply success => open modal confirm
    if (applySuccess) {
      openFn("modal-confirm");
    }
  }, [applySuccess]);

  useEffect(() => {
    if(message){
      openFn("modal-can_entry");
    }
  }, [message]);

  // apply Promotion
  const submit = () => {
    let listUpdate = [];
    list.map((p) => {
      let arrPromotionSetID = p.promotion_set_id.filter((id) =>
        check.includes("" + id)
      );

      listUpdate.push({ ...p, promotion_set_id: arrPromotionSetID });
    });

    const listPartner = listUpdate.filter((p) => {
      let checkTemp = false;
      for (const c of check) {
        if (p.promotion_set_id.includes(c)) {
          checkTemp = true;
          break;
        }
      }
      return checkTemp;
    });

    dispatch(
      applyPromotion({
        service: SERVICE,
        promotion_id: promotion.id,
        promotion_set: check,
        partnership: listPartner,
        p,
        q,
        referar: document.referrer
      })
    );

    // const promotion_set_id = [];
    // promotion_set?.map((item) => promotion_set_id.push(item.id));
    // dispatch(
    //   applyPromotion({
    //     service: SERVICE,
    //     promotion_id: promotion.id,
    //     promotion_set: promotion_set_id,
    //   })
    // );
  };

  const getListName = (id) => {
    const list_partner_id = list.filter((item) =>
      item.promotion_set_id.includes("" + id)
    );
    if (list_partner_id.length > 0) {
      return list_partner_id
        .map((item) => item.last_name + " " + item.first_name)
        .join(", ");
    }
    return "なし";
  };

  return (
    open && (
      <div className="modal active fw-600">
        <div className="modal-body">
          <div className="fs-16 fw-600 text-red-light text-center mt-2">
            こちらの案件に応募しますか?
          </div>

          <div className="border-color-black border-radius-5px px-3 py-2 my-3">
            <div className="fs-16 fs-sm-14">
              {/* DECORATION */}
              <span
                className="me-1"
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    promotion?.title_decoration?.title_decoration_content
                  ),
                }}
              ></span>

              {/* TITLE */}
              {promotion?.title_login}
            </div>
          </div>
          <div className="mt-2">
              {/* PROMOTION SET & PARTNER LIST */}
              {promotion_set.map((item) => {
                if (check.includes("" + item.id)) {
                  return (
                    <div key={item.id} className="my-2 fw-600 fs-13">
                      { promotion?.split_flg == 1 &&
                      <div className="bg-violet px-2 py-1 fs-sm-12 mb-sm-1-px">
                        {item.name}
                      </div>}
                      { promotion?.partner_flg == 1 &&
                      <div className="bg-pink px-2 py-1 py-1 fs-sm-9">
                        同行者：{getListName(item.id)}
                      </div>}
                    </div>
                  );
                }
              })}
            </div>

          {/* GROUP BUTTON */}
          <div className="group-btn-modal">
            <div onClick={closeFn} className="btn-modal">
              戻る
            </div>
            <div onClick={submit} className="btn-modal red-light">
              応募する
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalSubmit;
